import App from './App.svelte';
import "dragscroll";

const app = new App({
	target: document.body
});

export default app;